var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContentTaggingColBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1H1V8L7.29 14.29C8.23 15.23 9.77 15.23 10.71 14.29L14.29 10.71C15.23 9.77 15.23 8.23 14.29 7.29L8 1Z",
    fill: "#1B90FE",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.01V5",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1L20.3 7.3C20.5237 7.52297 20.7013 7.78791 20.8224 8.07964C20.9435 8.37136 21.0059 8.68413 21.0059 9C21.0059 9.31587 20.9435 9.62864 20.8224 9.92036C20.7013 10.2121 20.5237 10.477 20.3 10.7L16 15",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentTaggingColBlue);
export default __webpack_public_path__ + "static/media/content-tagging-col-blue.d70e69dc9ead1f5702067c6fe8981022.svg";
export { ForwardRef as ReactComponent };